// extracted by mini-css-extract-plugin
export default {"cc":"styles_cc__xhPXn","avatar":"styles_avatar__547-V","notAvailable":"styles_notAvailable__RgtYS","name":"styles_name__ZC96S"};